import { render, staticRenderFns } from "./ServerInfoTab.vue?vue&type=template&id=31fa3893&"
import script from "./ServerInfoTab.vue?vue&type=script&lang=js&"
export * from "./ServerInfoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports